import { DocumentService, GoogleDriveAdapter } from '@xq/infrastructure';

export class IsFileInSchoolStructureUseCase {
  static async execute(fileId: string) {
    return DocumentService.getInstance(
      GoogleDriveAdapter.getInstance()
    ).isInSchoolStructure(fileId);
  }
}
